<eva-header></eva-header>

<eva-command-palette></eva-command-palette>

<router-outlet></router-outlet>
